import { RENDER_DISCLAIMER } from '../data/style-library';

/**
 * The disclaimer is required on every page, every render, and every export
 * (CLAUDE.md 11). It is not configurable and it is not dismissible.
 *
 * Set in grey-600, which measures 7.08:1 on white. grey-400 and grey-500 are
 * border and large-text colours in this palette; the one piece of text on this
 * site that has to be read does not go in either of them.
 */
export default function Footer() {
  return (
    <footer className="mt-auto border-t border-grey-200 bg-grey-050">
      <div className="mx-auto w-full max-w-wrap px-gutter py-10">
        <p className="t-meta measure text-grey-600">{RENDER_DISCLAIMER}</p>
      </div>
    </footer>
  );
}
